export const Annual_Sales_Count_Payload = {
          name: "Annual Sales",
          // owner: "Administrator",
          // creation: "2020-07-20 20:17:16.568132",
          // modified: "2020-07-22 16:56:33.747156",
          // modified_by: "Administrator",
          // docstatus: 0,
          // idx: 0,
          // is_standard: 1,
          // module: "Selling",
          // label: "Annual Sales",
          // type: "Document Type",
          function: "Sum",
          aggregate_function_based_on: "base_net_total",
          document_type: "Sales Order",
          // is_public: 1,
          show_percentage_stats: 1,
          stats_time_interval: "Monthly",
          // filters_json: "[[\"Sales Order\",\"status\",\"not in\",[\"Draft\",\"Cancelled\",\"Closed\",null],false],[\"Sales Order\",\"docstatus\",\"=\",\"1\",false],[\"Sales Order\",\"modified\",\"Timespan\",\"this year\",false]]",
          // dynamic_filters_json: "[[\"Sales Order\",\"company\",\"=\",\"frappe.defaults.get_user_default(\\\"Company\\\")\"]]",
          // doctype: "Number Card",
          // __last_sync_on: "2025-07-31T09:22:28.985Z"
          };       

export const Sales_Orders_to_Deliver_Count_Payload = {
            name: "Sales Orders to Deliver",
            // owner: "Administrator",
            // creation: "2020-07-20 20:17:16.596857",
            // modified: "2020-07-22 14:19:28.833784",
            // modified_by: "Administrator",
            // docstatus: 0,
            // idx: 2,
            // is_standard: 1,
            // module: "Selling",
            // label: "Sales Orders to Deliver",
            // type: "Document Type",
            function: "Count",
            document_type: "Sales Order",
            is_public: 1,
            show_percentage_stats: 1,
            stats_time_interval: "Weekly",
            // filters_json: JSON.stringify([
            //   ["Sales Order", "status", "in", ["To Deliver and Bill", "To Deliver", null], false],
            //   ["Sales Order", "docstatus", "=", "1", false]
            // ]),
            // dynamic_filters_json: JSON.stringify([
            //   ["Sales Order", "company", "=", "frappe.defaults.get_user_default(\"Company\")"]
            // ]),
            // doctype: "Number Card",
            // __last_sync_on: "2025-08-01T06:31:18.410Z"
          };

export const Active_Customer_Count_Payload = {
  name: "Active Customers",
  // owner: "Administrator",
  // creation: "2020-07-20 20:17:16.653866",
  // modified: "2020-07-22 14:20:32.268103",
  // modified_by: "Administrator",
  // docstatus: 0,
  // idx: 2,
  // is_standard: 1,
  // module: "Selling",
  // label: "Active Customers",
  // type: "Document Type",
  function: "Count",
  document_type: "Customer",
  is_public: 1,
  show_percentage_stats: 1,
  stats_time_interval: "Monthly",
  // filters_json: JSON.stringify([
  //   ["Customer", "disabled", "=", "0"]
  // ]),
  // dynamic_filters_json: "", // This is an empty string, so keep it as-is
  // doctype: "Number Card",
  // __last_sync_on: "2025-08-01T06:31:18.576Z"
};  

export const Sales_Order_to_Bill_Count_Payload = {
          name: "Sales Orders to Bill",
          // owner: "Administrator",
          // creation: "2020-07-20 20:17:16.625001",
          // modified: "2020-07-22 14:20:09.918626",
          // modified_by: "Administrator",
          // docstatus: 0,
          // idx: 2,
          // is_standard: 1,
          // module: "Selling",
          // label: "Sales Orders to Bill",
          // type: "Document Type",
          function: "Count",
          document_type: "Sales Order",
          is_public: 1,
          show_percentage_stats: 1,
          stats_time_interval: "Weekly",
          // filters_json: JSON.stringify([
          //   ["Sales Order", "status", "in", ["To Deliver and Bill", "To Bill", null], false],
          //   ["Sales Order", "docstatus", "=", "1", false]
          // ]),
          // dynamic_filters_json: JSON.stringify([
          //   ["Sales Order", "company", "=", "frappe.defaults.get_user_default(\"Company\")"]
          // ]),
          // doctype: "Number Card",
          // __last_sync_on: "2025-08-01T06:31:18.489Z"
        };


       
export const createFilterState = (timeInterval = 'Monthly', extraFields = {}) => ({
  dateFilters: [{ label: "From Date", value: '' }, { label: "To Date", value: '' }],
  timeInterval,
  ...extraFields
});
